
const ESGProfilePageAr = () => {
  return (
    <main className="page" id="main">
        <div className="ifram-page">
            <img 
                src={require('../../../assets/images/wallpaper/esg-profile.jpg')}
                className="background-image"
                alt="ESG Profile Background image"
            />
            <iframe 
                src="https://esg.churchgatepartners.com/login/companyprofile?id=370030003800240024004100530048004F004B0041004E0041004E00590041004100560041004E004900410053004800570049004E00490024002400"
                className="ifram"
                title="ESG Churchgate Partners"
                aria-hidden="true"
            />
        </div>
    </main>
  )
}

export default ESGProfilePageAr